import { graphql } from "@/graphql";

export const acceptTermsAndConditionsMutation = graphql(`
  mutation AcceptTermsAndConditions($input: TermsAndConditionsAcceptInput!) {
    termsAndConditionsAccept(input: $input) {
      success
      errors {
        field
        message
      }
    }
  }
`);
